<template>
  <el-select v-model="tagType"
    style="vertical-align: top;"
    placeholder="请选择标签"
    @change="handleChange"
    clearable>
    <el-option v-if="showAll"
      label="全部"
      :value="null"></el-option>
    <el-option v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import BaseData from '@/utils/baseData'
export default {
  name: 'vendor-label-select',
  components: {},
  props: {
    exclude: {
      type: Array,
      default () {
        return []
      }
    },
    showAll: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {
    tagType: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    'option.vendorId': {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.fetchList()
        }
      },
      immediate: true
    }
    // option: {
    //   handler (val) {
    //     if (val.vendorId) {
    //       this.fetchList()
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  methods: {
    handleChange () {
      this.callback && this.callback()
    },
    fetchList () {
      this.$store.dispatch('vendor/getvendortagtypes', {
        payload: this.option,
        success: (res) => {
          let tagTypes = res.data.tagTypes
          this.list = BaseData.tags.filter(item => tagTypes.indexOf(+item.value) > -1 && this.exclude.indexOf(+item.value) === -1)
        },
        fail: () => {
          this.list = []
        }
      })
    }
  },
  created () { },
  mounted () {
    // this.fetchList()
  }
}
</script>
<style lang="stylus" scoped></style>
